export const getUrlParams = (url) => {
    let urlData = url || window.location.href
    if (urlData && urlData.charAt(urlData.length - 1) == '#') {
        urlData = urlData.substr(0, urlData.length - 1)
    }
    let urlparams = urlData.split('?')
    if (urlparams.length === 1) {
        return ''
    }
    var newparams = {}
    for (let item of urlparams[1].split('&')) {
        newparams[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
    }
    return newparams
}

export const paramToString = (data = {}) => Object.entries(data)
    .reduce((queryString, [key, value = '']) =>
            (queryString ? `${queryString}&` : '') + `${key}=${value ? value.toString() : ''}`,
        '')


// https://cdn.lexus.areyeshot.com/uploads/car-model/newWeb/officialwebsite/template.html#rz
// const iframe_360 = document.getElementById('iframe_360');
// const mWin =iframe_360 ? (iframe_360.window || iframe_360.contentWindow) : window;
// console.log(JSON.stringify({
//     ratio: Math.floor(Math.max(window.innerWidth / window.innerHeight, window.innerHeight / window.innerWidth) * 10000) / 10000,
//     camera: mWin.appInstance.camera.position.toArray()
// }, null, 4))

export const isMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
    navigator.userAgent
)


export const getCameraConfig = (car,) => {
    const pcHeight = window.innerHeight
    if (!isMobile) {
        if (pcHeight >= 960) return [
            -4.929188262919067,
            1.3699030203961717,
            4.04475066458583
        ]
        else if (pcHeight >= 860) return [-7.2536087477033115, 2.10357052397561, 3.8093448862255155]
        else if (pcHeight >= 660) [-5.749308413606292, 1.537931055254858, 4.717717763344592]
        else return [-6.402998420790932, 1.6718605133006763, 5.25411705466064]
    }


    const aspectRatio = {
        rz: [
            {
                "ratio": 1.7358,
                "camera": [
                    -8.610148412956494,
                    1.8384230789247424,
                    3.6050370498638737
                ]
            },
            {
                "ratio": 1.3512,
                "camera": [
                    -10.318320878861412,
                    3.9313738709539665,
                    10.702549381217542
                ]
            },
            {
                "ratio": 1.2729,
                "camera": [
                    -9.80885020799314,
                    4.633846450207866,
                    10.675743675175196
                ]
            },
            {
                "ratio": 0.7076,
                "camera": [
                    -6.85515282632997,
                    2.365854815132553,
                    4.996355718314195
                ]
            },
        ],
        rx: [
            {
                "ratio": 1.4897,
                "camera": [
                    -13.120271816492263,
                    3.524074451534363,
                    8.334386121165137
                ]
            },
            {
                "ratio": 1.464,
                "camera": [
                    -13.241446910531572,
                    3.4909694324945146,
                    7.823742070018229
                ]
            },
            {
                "ratio": 1.1182,
                "camera": [
                    -9.37701407910442,
                    3.103765065294255,
                    6.8344060448800485
                ]
            },
            {
                "ratio": 1.0123,
                "camera": [
                    -8.54896653433164,
                    2.8614738725346056,
                    6.230886299926902
                ]
            },
            {
                "ratio": 0.3702,
                "camera": [
                    -5.15238276317729,
                    1.8181341935513307,
                    6.903431251923272
                ]
            },
            {
                "ratio": 1.1425,
                "camera": [
                    -11.336944224506196,
                    3.6772512324264777,
                    8.262894721582116
                ]
            },
            {
                "ratio": 1.3512,
                "camera": [
                    -6.042181677090318,
                    2.18226268085797,
                    6.523380654121319
                ]
            },
            {
                "ratio": 1.2729,
                "camera": [
                    -9.80885020799314,
                    4.633846450207866,
                    10.675743675175196
                ]
            },
            {
                "ratio": 0.7076,
                "camera": [
                    -6.85515282632997,
                    2.365854815132553,
                    4.996355718314195
                ]
            },
        ],
        ls:[
            {
                "ratio": 1,
                "camera": [-13.150397807506716, 4.147886772353922, 6.881346178650771]
            }
        ],
        es:[
            {
                "ratio": 1,
                "camera": [
                    -13.878609938321485,
                    2.7182885868759117,
                    5.182349781653847
                ]
            }
        ],
        // 390  414

        default: [
            {
                "ratio": 1.3512,
                "camera": [
                    -6.377988046045119,
                    2.567547150773989,
                    6.615488393606279
                ]
            },
            {
                "ratio": 1.2729,
                "camera": [
                    -9.42462332773194,
                    3.2120525430223723,
                    12.611196272448167
                ]
            },
            {
                "ratio": 0.7076,
                "camera": [
                    -5.890389579832466,
                    2.142532839388983,
                    7.881997670280102
                ]
            },
            {
                "ratio": 0.5649,
                "camera": [
                    -4.727311549561474,
                    2.187737120695959,
                    6.210923315376906
                ]
            },
            {
                "ratio": 0.482,
                "camera": [
                    -4.762226513407122,
                    1.801913002438698,
                    5.120900867427312
                ]
            },
            {
                "ratio": 0.0892,
                "camera": [
                    -3.5737703653793065,
                    1.3713838604736228,
                    4.788323997175795
                ]
            }
        ]
    }
    const carAspectRatio = Object.values(
        aspectRatio.default.concat(aspectRatio[car] || []).reduce((tar, item) => {
            tar[item.ratio] = item
            return tar
        }, {})
    )

    const width = window.innerWidth
    const height = pcHeight
    const ratio = (height / width).toFixed(4)
    const aspectItem = carAspectRatio.sort((a, b) => b.ratio - a.ratio).find(r => ratio === 1 ? r.ratio <= ratio : ratio >= r.ratio) || {}

    return aspectItem?.camera || []
}

// const iframe_360 = document.getElementById('iframe_360');
// const mWin = iframe_360 ? (iframe_360.window || iframe_360.contentWindow) : window;
// mWin.appInstance.camera.position.toArray()
//
// const width = window.innerWidth
// const height = document.querySelector('.b-content').getBoundingClientRect().top - document.querySelector('.select-car').getBoundingClientRect().bottom
// const ratio = (height / width)
// console.log(JSON.stringify({
//     ratio: Math.floor(ratio * 10000) / 10000,
//     camera: mWin.appInstance.camera.position.toArray()
// }, null, 4))


export function isInIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true; // 无法访问 top，默认为在 iframe 中
    }
}
